import { render, staticRenderFns } from "./MenusAdd.vue?vue&type=template&id=a1996838&scoped=true&"
import script from "./MenusAdd.vue?vue&type=script&lang=js&"
export * from "./MenusAdd.vue?vue&type=script&lang=js&"
import style0 from "./MenusAdd.vue?vue&type=style&index=0&id=a1996838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1996838",
  null
  
)

export default component.exports